// infcode_change - metrics foundation
import { Identity } from "@kilocode/kilo-telemetry/identity"
import * as Log from "@opencode-ai/core/util/log"
import { AuthStorage } from "../auth/storage"
import { trimmedText, userIdFrom } from "./text"

const LOG_PREFIX = "[metrics:identity]"
const log = Log.create({ service: LOG_PREFIX })

export type MetricsIdentity = {
  deviceId: string
  userId: string
}

type ResolveIdentityOptions = {
  authDir?: string
  machineId?: () => Promise<string | undefined>
}

export async function resolveMetricsIdentity(input: ResolveIdentityOptions = {}): Promise<MetricsIdentity> {
  const deviceId = await resolveDeviceId(input.machineId ?? Identity.getMachineId)
  const userId = await resolveMetricsUserId(deviceId, input.authDir ? { authDir: input.authDir } : {})
  return {
    deviceId,
    userId,
  }
}

async function resolveMetricsUserId(deviceId: string, input: Pick<ResolveIdentityOptions, "authDir"> = {}) {
  const cfg = await AuthStorage.load(input.authDir ? { dir: input.authDir } : {})
  return userIdFrom(cfg.userInfo, deviceId)
}

async function resolveDeviceId(machineId: () => Promise<string | undefined>) {
  try {
    return trimmedText(await machineId()) ?? "unknown-device"
  } catch (err) {
    log.warn("failed to resolve machine id", {
      error: err instanceof Error ? err.message : String(err),
    })
    return "unknown-device"
  }
}
